import Head from 'next/head';
import { handleFreeReturn } from '@lambda/commons/helpers';
import settings from '@/settings';
import i18n from '@/settings/i18n';
import { WebsiteSchema } from '../../../homepage/WebsiteSchema';

const t = i18n.init();

const freeReturnDays = handleFreeReturn(
  settings.store,
  settings.free_return_days,
);

export default function CollectionDefaultSeo(props: {
  title: string;
  type?: string;
  priceRange?: {
    min: number;
    max: number;
  };
  currency?: string;
  productImage?: string;
}) {
  const { title, type, priceRange, currency, productImage } = props;
  let metaTitle = '';
  let metaContent = '';

  if (type && type === 'brand') {
    metaTitle = t`Best Deals for Refurbished & Unlocked ${{ title }}`;
    metaContent = t`Get the best value & price for all ${{
      title,
    }} models now up to 70% off. Shop with peace of mind & guaranteed satisfaction with 1 year warranty ✔️ ${{
      free_return_days: freeReturnDays,
    }}-day returns ✔️`;
  } else {
    metaTitle = t`Premium & Certified Refurbished ${{ title }} on Reebelo`;
    metaContent = t`Make your ${{
      title,
    }} upgrade sustainable with Reebelo. Shop a wide selection of iPhones, Samsung Galaxy, Google Pixel, and more. Up to 70% off & ${{
      free_return_days: freeReturnDays,
    }}-day returns`;
  }

  const productData = {
    '@context': 'http://schema.org/',
    '@type': 'Product',
    name: title,
    description: metaContent,
    image: productImage,
    offers: {
      '@type': 'AggregateOffer',
      lowPrice: priceRange?.min?.toFixed(2),
      highPrice: priceRange?.max?.toFixed(2),
      priceCurrency: currency,
    },
  };

  return (
    <Head>
      <title>{metaTitle}</title>
      <WebsiteSchema />
      {title === 'Laptops & Desktops' && (
        <script
          key="structured-data"
          type="application/ld+json"
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: JSON.stringify(productData) }}
        />
      )}
      <meta name="description" content={metaContent} />
    </Head>
  );
}
